export default __webpack_public_path__ + "static/media/img_about04-m.43534238.png";